import { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

interface Props {
  className?: string;
}

export const IconDocument = forwardRef<SVGSVGElement, Props>((props, ref) => {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M20.8387 20.8394C20.8387 21.2656 20.6693 21.6745 20.368 21.9758C20.0667 22.2772 19.6578 22.4466 19.2316 22.4466H4.7673C4.34105 22.4466 3.93228 22.2772 3.63087 21.9758C3.32948 21.6745 3.16016 21.2656 3.16016 20.8394V3.16085C3.16016 2.73461 3.32948 2.32583 3.63087 2.02443C3.93228 1.72303 4.34105 1.55371 4.7673 1.55371H15.2137L20.8387 7.17871V20.8394Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98242 7.98193H11.1967"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98242 12.8037H16.0181"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98242 17.625H16.0181"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
IconDocument.displayName = 'IconDocument';
